import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { LoginSuccess, SetUserData } from "../../utils/redux/slices/authSlice";
import { useNavigate } from "react-router-dom";
import { data } from "jquery";
import { Link } from "react-router-dom";
import Cookies from "js-cookie"
import { useConfig } from "../../utils/ConfigContext.jsx";
import {createAxiosInstance} from "../../utils/AxiosInstance.jsx";


const VerifyMsgComponent = () => {
    const [code, setCode] = useState("");
    const [error, setError] = useState("");
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const user_name = useSelector((state) => state.auth.user_name);
     const { API_BASE_URL } = useConfig(); // ✅ from context

    const handleVerify = async () => {
        try {
            // ✅ Create axios instance dynamically with correct base URL
             const AxiosInstance = createAxiosInstance(API_BASE_URL);
           

            const res = await AxiosInstance.post("/auth/verify-otp", {
                user_name: user_name,
                otp: code,
            });
            // api response
            const { access_token, long_lived_token } = res.data;
            // save data on localStorage
            // localStorage.setItem("accessToken", access_token);
            // localStorage.setItem("refreshToken", long_lived_token);

            // Set refresh token on cookie storage
            Cookies.set('refreshToken', long_lived_token, { expires: 20, secure: true, sameSite: 'Strict' });

            localStorage.setItem("user_name", user_name);

            dispatch(LoginSuccess({
                accessToken: access_token,
                user_name: user_name,
            }));
            // Set token for axiosInstance manually
            AxiosInstance.defaults.headers.common["Authorization"] = `Bearer ${access_token}`;

            // Fetch user detail api
            const userRes = await AxiosInstance.post("/me");

            //save user data on local storade
            localStorage.setItem("userData", JSON.stringify(userRes.data));
            // add user data in to redux store
            dispatch(SetUserData(userRes.data)); // Save full user info
            //navigate to dashboard
            navigate("/");
        } catch (err) {
            setError("Invalid or expired code");
        }
    };


    return (
        <div className="d-flex flex-column align-items-center justify-content-center p-4">
            <div className="bg-white p-4 w-100 max-w-400 text-center">
                <Link to="/" className="mb-24" style={{ width: "75px" }}>
                    <img src="assets/images/logo.webp" alt="" />
                </Link>
                <h2 className="h4 mb-2">Two-factor authentication</h2>
                <p className="text-muted">Enter the code sent to your mail.</p>
                <input
                    type="text"
                    className="form-control mt-3 text-center"
                    placeholder="Enter code"
                    value={code}
                    onChange={(e) => setCode(e.target.value)}
                />
                {error && <div className="text-danger mt-2">{error}</div>}
                <button className="btn btn-primary mt-3 w-100" onClick={handleVerify}>
                    Verify
                </button>
            </div>
        </div>
    );
};

export default VerifyMsgComponent;
